export const styles = {
  mainContainer: {
    height: 'calc(100vh - 64px)', 
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: '#fff'
  },
  tabHeader: {
    backgroundColor: '#fff',
    borderBottom: '1px solid #dee2e6',
    padding: '16px 0 0 0'
  },
  tabStyle: {
    marginBottom: '-1px'
  },
  contentArea: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'auto',  
    padding: '20px 0',
    backgroundColor: '#fff',
    WebkitOverflowScrolling: 'touch', 
  },
  tabsContainer: {
    display: 'flex',
    justifyContent: 'between',
    alignItems: 'center'
  }
};
